import axios from 'axios';
import { PIM_BASE_URL } from '../constants';

const PIM_INVOICE_URL = PIM_BASE_URL + "/invoices"

export function getListInvoices(filter){
    return axios.post(`${PIM_INVOICE_URL}/list`, filter).then(res => res.data).catch(error => console.log(error));
}